module.exports = __webpack_public_path__ + "static/img/p4.0d81f54d.png";